<span class="image">
    <img *ngIf="url; else no_image" loading="lazy" class="round-image"
        [src]="url | cloudimageCrop:width:height">
    <ng-template #no_image>
        <img *ngIf="useDefaultMissingImage" class="no-image" [src]="noProfileImage | cloudimageCrop:width:height">
        <span *ngIf="!useDefaultMissingImage" class="no-image" [style.font-size.px]="width">
            <i class="fa-solid fa-user"></i>
        </span>
    </ng-template>
</span>